import { render, staticRenderFns } from "./PicklOverview.vue?vue&type=template&id=8e413d8c&scoped=true&"
import script from "./PicklOverview.vue?vue&type=script&lang=js&"
export * from "./PicklOverview.vue?vue&type=script&lang=js&"
import style0 from "./PicklOverview.vue?vue&type=style&index=0&id=8e413d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e413d8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e413d8c')) {
      api.createRecord('8e413d8c', component.options)
    } else {
      api.reload('8e413d8c', component.options)
    }
    module.hot.accept("./PicklOverview.vue?vue&type=template&id=8e413d8c&scoped=true&", function () {
      api.rerender('8e413d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PicklOverview.vue"
export default component.exports